<template>
  <sp-container flex rowgap="1" direction="column" class="context-menu__style-options">
    <BoxModelUI
      v-model="model.ui.padding"
      name="padding"
      min="0"
      max="200"
      :value-and-unit-width="paddingValueAndUnitWidth"
      value-and-unit-width-locked="6ch"
      @update:short-hand="updatePadding"
    />
    <sp-divider></sp-divider>

    <BoxModelUI
      v-model="model.ui.margin"
      name="margin"
      default-value="0"
      min="-200"
      max="200"
      auto
      :value-and-unit-width="marginValueAndUnitWidth"
      :value-button-width="marginValueButtonWidth"
      value-and-unit-width-locked="6ch"
      @update:short-hand="updateMargin"
    />
    <sp-divider></sp-divider>

    <Background v-model="model" />
    <sp-divider></sp-divider>

    <Dimensions v-model="model" />
  </sp-container>
</template>

<script setup>
import { computed } from "vue";
import Background from "./StyleOptionsBackground.ce.vue";
import BoxModelUI from "./BoxModelUI.ce.vue";
import Dimensions from "./StyleOptionsDimensions.ce.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const model = computed(() => props.modelValue);
const paddingValueAndUnitWidth = "6ch";
const marginValueAndUnitWidth = "7ch";
const marginValueButtonWidth = "5ch";

function updatePadding(value) {
  model.value.padding = value;
}

function updateMargin(value) {
  model.value.margin = value;
}
</script>

<style lang="scss" scoped>
.context-menu__style-options {
  --style-options-stripe-bg: repeating-linear-gradient(
    -45deg,
    hsl(0, 0%, 90%),
    hsl(0, 0%, 90%) 10px,
    hsl(0, 0%, 80%) 10px,
    hsl(0, 0%, 80%) 20px
  );
}
sp-divider {
  opacity: 0.5;
}
</style>
